







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class IconbarItem extends Vue {
  @Prop() iconName: string | undefined;

  sidePanelWidth: string = '0';

  showSidepanel() {
    this.$emit('showingSidepanel');
  }
}
